/* =============================================
   HUMYN HEALTH — GLOBAL JS
   All three pages: homepage, product, story
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

/* ——————————————————————————————————————
   HOMEPAGE JS
   —————————————————————————————————————— */

/* ---------- Drawer open/close ---------- */
(function(){
  const btn = document.getElementById('menuBtn');
  const drawer = document.getElementById('drawer');
  const backdrop = document.getElementById('drawerBackdrop');
  const close = document.getElementById('drawerClose');
  if(!btn) return;
  function open(){ drawer.classList.add('open'); backdrop.classList.add('open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function shut(){ drawer.classList.remove('open'); backdrop.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  btn.addEventListener('click', open);
  close.addEventListener('click', shut);
  backdrop.addEventListener('click', shut);
  drawer.querySelectorAll('[data-close]').forEach(a => a.addEventListener('click', shut));
})();

/* ---------- Hero Carousel, drag · swipe · keyboard ---------- */
(function(){
  const slidesEl = document.getElementById('slides');
  const slides = slidesEl ? slidesEl.querySelectorAll('.slide') : [];
  const counter = document.getElementById('counter');
  const total = slides.length;
  if(!slidesEl || !total) return;
  let idx = 0, timer, dragStartX = 0, isDragging = false, dragMoved = false;

  function go(to, dir){
    const prev = slides[idx];
    idx = (to + total) % total;
    const next = slides[idx];

    prev.classList.remove('is-active');
    prev.style.transform = dir === 1 ? 'translateX(-40px)' : 'translateX(40px)';
    prev.style.opacity = '0';
    setTimeout(()=>{ prev.style.transform=''; prev.style.opacity=''; }, 900);

    next.style.transform = dir === 1 ? 'translateX(40px)' : 'translateX(-40px)';
    next.style.opacity = '0';
    next.classList.add('is-active');
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      next.style.transform = '';
      next.style.opacity = '';
    }));

    if(counter) counter.textContent = String(idx+1).padStart(2,'0') + ' / ' + String(total).padStart(2,'0');
  }

  function start(){ stop(); timer = setInterval(()=> go(idx+1, 1), 5800); }
  function stop(){ if(timer) clearInterval(timer); }

  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  if(prevBtn) prevBtn.addEventListener('click', ()=>{ go(idx-1, -1); start(); });
  if(nextBtn) nextBtn.addEventListener('click', ()=>{ go(idx+1, 1); start(); });

  document.addEventListener('keydown', e => {
    if(e.key === 'ArrowLeft'){ go(idx-1, -1); start(); }
    if(e.key === 'ArrowRight'){ go(idx+1, 1); start(); }
  });

  slidesEl.addEventListener('mousedown', e=>{ isDragging=true; dragMoved=false; dragStartX=e.clientX; slidesEl.style.cursor='grabbing'; });
  slidesEl.addEventListener('mousemove', e=>{ if(isDragging && Math.abs(e.clientX-dragStartX)>8) dragMoved=true; });
  slidesEl.addEventListener('mouseup', e=>{
    slidesEl.style.cursor='';
    if(isDragging && dragMoved){
      const dx=e.clientX-dragStartX;
      if(Math.abs(dx)>60){ dx<0 ? go(idx+1,1) : go(idx-1,-1); start(); }
    }
    isDragging=false; dragMoved=false;
  });
  slidesEl.addEventListener('mouseleave', e=>{ if(isDragging){ isDragging=false; slidesEl.style.cursor=''; } stop(); });
  slidesEl.addEventListener('mouseenter', stop);

  let touchX=0;
  slidesEl.addEventListener('touchstart', e=>{ touchX=e.touches[0].clientX; }, {passive:true});
  slidesEl.addEventListener('touchend', e=>{
    const dx=e.changedTouches[0].clientX-touchX;
    if(Math.abs(dx)>50){ dx<0 ? go(idx+1,1) : go(idx-1,-1); start(); }
  }, {passive:true});

  slidesEl.style.cursor='grab';
  start();
})();

/* ---------- Reveal on scroll ---------- */
(function(){
  const els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  if(!els.length) return;
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('visible'); io.unobserve(e.target); } });
  }, { threshold:0.1, rootMargin:'0px 0px -40px 0px' });
  els.forEach(el => io.observe(el));
})();

/* ---------- Sticky mobile CTA (homepage) ---------- */
(function(){
  const cta = document.getElementById('stickyCta');
  if(!cta) return;
  let shown = false;
  window.addEventListener('scroll', ()=>{
    if(window.scrollY > 600 && !shown){ cta.classList.remove('hidden'); shown=true; }
  }, {passive:true});
})();

/* ---------- Desktop Sticky Buy Bar (homepage) ---------- */
(function(){
  const bar = document.getElementById('stickyBuyBar');
  const nav = document.querySelector('.nav');
  const product = document.getElementById('product');
  if(!bar || !nav || !product) return;
  window.addEventListener('scroll', ()=>{
    const navBottom = nav.getBoundingClientRect().bottom;
    const productTop = product.getBoundingClientRect().top;
    if(navBottom < 0 && productTop > window.innerHeight){
      bar.classList.add('visible');
    } else {
      bar.classList.remove('visible');
    }
  }, {passive:true});
})();

/* ---------- Timeline progress bar animation (homepage) ---------- */
(function(){
  const steps = document.querySelectorAll('.how-step');
  if(!steps.length) return;
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){ e.target.classList.add('in-view'); io.unobserve(e.target); }
    });
  }, {threshold:0.4});
  steps.forEach(s => io.observe(s));
})();

/* ——————————————————————————————————————
   PRODUCT PAGE JS
   —————————————————————————————————————— */

/* Progress bar */
(function(){
  const prog = document.getElementById('prog');
  if(!prog) return;
  window.addEventListener('scroll', () => {
    const scrolled = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
    prog.style.width = Math.min(scrolled, 100) + '%';
  }, {passive:true});
})();

/* Sticky buy bar (product page) */
(function(){
  const stickyBuy = document.getElementById('stickyBuy');
  const buySection = document.getElementById('buy-section');
  if (!stickyBuy || !buySection) return;
  const observer = new IntersectionObserver(([entry]) => {
    stickyBuy.classList.toggle('visible', !entry.isIntersecting);
  }, { threshold: 0 });
  observer.observe(buySection);
})();

/* Tab switching */
window.showTab = function(id, btn) {
  document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
  document.querySelectorAll('.ctab').forEach(b => b.classList.remove('active'));
  const panel = document.getElementById(id);
  if(panel) {
    panel.classList.add('active');
    /* Force reveal on newly active tab content */
    panel.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => {
      el.classList.add('visible');
    });
  }
  btn.classList.add('active');
  const tabs = document.getElementById('contentTabs');
  if(tabs) {
    const tabsTop = tabs.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: tabsTop - 70, behavior: 'smooth' });
  }
};

/* FAQ accordion */
// window.toggleFaq = function(btn) {
//   const item = btn.closest('.faq-item');
//   const wasOpen = item.classList.contains('open');
//   document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
//   if (!wasOpen) item.classList.add('open');
// };
// window.toggleFaq = function(btn) {
//   const item = btn.closest('.faq-item');
//   const wasOpen = item.classList.contains('open');

//   document.querySelectorAll('.faq-item').forEach(i => {
//     i.classList.remove('open');
//   });

//   if (!wasOpen) {
//     item.classList.add('open');

//     setTimeout(() => {
//       item.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });
//     }, 50);
//   }
// };

window.toggleFaq = function(btn) {
  const item = btn.closest('.faq-item');
  const wasOpen = item.classList.contains('open');

  // If clicking the already-open FAQ, just close it
  if (wasOpen) {
    item.classList.remove('open');
    return;
  }

  // Remember where the clicked FAQ is before changing the layout
  const itemTop = item.getBoundingClientRect().top + window.scrollY;

  // Close all FAQs
  document.querySelectorAll('.faq-item').forEach(i => {
    i.classList.remove('open');
  });

  // Open clicked FAQ
  item.classList.add('open');

  // Keep the clicked FAQ in the same viewport position
  requestAnimationFrame(() => {
    const newItemTop = item.getBoundingClientRect().top + window.scrollY;
    const scrollDifference = newItemTop - itemTop;

    window.scrollTo({
      top: window.scrollY + scrollDifference,
      behavior: 'instant'
    });
  });
};

// /* Thumbnail swap (product page) */
// (function(){
//   const mainImg = document.getElementById('mainImg');
//   if(!mainImg) return;
//   document.querySelectorAll('.prod-thumb').forEach(t => {
//     t.addEventListener('click', () => {
//       document.querySelectorAll('.prod-thumb').forEach(b => b.classList.remove('active'));
//       t.classList.add('active');
//       mainImg.src = t.getAttribute('data-img');
//     });
//   });
// })();

(function () {

  const mainImg = document.getElementById('mainImg');
  const thumbRow = document.getElementById('prodThumbRow');

  if (!mainImg || !thumbRow) return;

  const thumbs = Array.from(
    thumbRow.querySelectorAll('.prod-thumb')
  );

  const thumbPrev = document.querySelector('.prod-thumb-prev');
  const thumbNext = document.querySelector('.prod-thumb-next');

  const mainPrev = document.querySelector('.prod-main-prev');
  const mainNext = document.querySelector('.prod-main-next');

  if (!thumbs.length) return;


  /* Current image */
  let currentIndex = 0;


  /* Change main image */
  function changeImage(index) {

    if (index < 0) {
      index = thumbs.length - 1;
    }

    if (index >= thumbs.length) {
      index = 0;
    }

    currentIndex = index;

    const thumb = thumbs[currentIndex];

    const imageUrl = thumb.getAttribute('data-img');

    if (imageUrl) {
      mainImg.src = imageUrl;
    }


    /* Update active thumbnail */
    thumbs.forEach((item, i) => {
      item.classList.toggle(
        'active',
        i === currentIndex
      );
    });


    /* Keep active thumbnail visible */
    thumb.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }


  /* Thumbnail click */
  thumbs.forEach((thumb, index) => {

    thumb.addEventListener('click', () => {
      changeImage(index);
    });

  });


  /* Main image - Previous */
  if (mainPrev) {

    mainPrev.addEventListener('click', () => {
      changeImage(currentIndex - 1);
    });

  }


  /* Main image - Next */
  if (mainNext) {

    mainNext.addEventListener('click', () => {
      changeImage(currentIndex + 1);
    });

  }


  /* Thumbnail navigation */
  function updateThumbArrows() {

    const maxScroll =
      thumbRow.scrollWidth - thumbRow.clientWidth;

    if (thumbPrev) {
      thumbPrev.classList.toggle(
        'is-hidden',
        thumbRow.scrollLeft <= 5
      );
    }

    if (thumbNext) {
      thumbNext.classList.toggle(
        'is-hidden',
        thumbRow.scrollLeft >= maxScroll - 5
      );
    }
  }


  /* Thumbnail previous */
  if (thumbPrev) {

    thumbPrev.addEventListener('click', () => {

      thumbRow.scrollBy({
        left: -(thumbRow.clientWidth * 0.75),
        behavior: 'smooth'
      });

    });

  }


  /* Thumbnail next */
  if (thumbNext) {

    thumbNext.addEventListener('click', () => {

      thumbRow.scrollBy({
        left: thumbRow.clientWidth * 0.75,
        behavior: 'smooth'
      });

    });

  }


  /* Update thumbnail arrows */
  thumbRow.addEventListener(
    'scroll',
    updateThumbArrows
  );

  window.addEventListener(
    'resize',
    updateThumbArrows
  );


  /* Initial state */
  updateThumbArrows();

})();

/* On page load — force reveal on the default active tab */
(function(){
  const activePanel = document.querySelector('.tab-panel.active');
  if(!activePanel) return;
  activePanel.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => {
    el.classList.add('visible');
  });
})();

}); /* end DOMContentLoaded */

/* =============================================
   PACK COMPARISON TABLE
   Builds a "compare packs" table under the size buttons from the
   product's own variant data (#ProductVariantsJSON), so prices, savings
   and per-day cost always match Shopify. Safe to load more than once.
   ============================================= */
(function () {
  if (window.__humynPackCompare) return;
  window.__humynPackCompare = true;

  var CSS = [
    '.hpc{margin:18px 0 6px;background:#fff;color:#1d2a58;border-radius:16px;padding:14px 14px 10px;box-shadow:0 6px 24px rgba(0,0,0,.12);font-family:inherit;text-align:left}',
    '.hpc-title{font-size:13px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;margin:0 0 2px}',
    '.hpc-sub{font-size:12px;color:#6b7390;margin:0 0 10px}',
    '.hpc-grid{display:grid;grid-template-columns:1.25fr 1.05fr .95fr .8fr;align-items:center;column-gap:8px}',
    '.hpc-head{font-size:11px;font-weight:600;color:#6b7390;text-transform:uppercase;letter-spacing:.06em;padding:0 10px 6px 38px}',
    '.hpc-row{display:grid;grid-template-columns:1.25fr 1.05fr .95fr .8fr;align-items:center;column-gap:8px;width:100%;margin:0 0 6px;position:relative;padding:10px 10px 10px 38px;border:1.5px solid #e3e8f4;border-radius:12px;background:#fff;color:inherit;font:inherit;text-align:left;cursor:pointer;transition:background .15s,border-color .15s}',
    '.hpc-row:hover{background:#f4f7ff}',
    '.hpc-dot{position:absolute;left:13px;top:50%;width:16px;height:16px;margin-top:-8px;border:2px solid #9aa3c0;border-radius:50%;background:#fff;box-sizing:border-box;transition:border-color .15s}',
    '.hpc-row:hover .hpc-dot{border-color:#1d2a58}',
    '.hpc-row.is-selected .hpc-dot{border-color:#1d2a58}',
    '.hpc-row.is-selected .hpc-dot::after{content:"";position:absolute;top:2px;right:2px;bottom:2px;left:2px;border-radius:50%;background:#1d2a58}',
    '.hpc-row:disabled .hpc-dot{opacity:.5}',
    '.hpc-opts-hidden{display:none !important}',
    '.hpc-row.is-selected{border-color:#1d2a58;background:#eaf0ff}',
    '.hpc-row:disabled{opacity:.45;cursor:not-allowed}',
    '.hpc-row:focus-visible{outline:2px solid #1d2a58;outline-offset:2px}',
    '.hpc-pack b{display:block;font-size:15px;font-weight:700}',
    '.hpc-pack small{display:block;font-size:11px;color:#6b7390;margin-top:1px}',
    '.hpc-best{display:inline-block;margin-top:4px;padding:2px 8px;border-radius:99px;background:#1f9d55;color:#fff;font-size:10px;font-weight:700;letter-spacing:.05em;text-transform:uppercase}',
    '.hpc-price b{display:block;font-size:15px;font-weight:700}',
    '.hpc-price s{display:block;font-size:11px;color:#8a8fa3}',
    '.hpc-save span{display:inline-block;padding:3px 9px;border-radius:99px;background:#e3f6ea;color:#0f6b3a;font-size:12px;font-weight:700;white-space:nowrap}',
    '.hpc-save em{font-style:normal;color:#8a8fa3;font-size:12px}',
    '.hpc-day{font-size:13px;font-weight:600;white-space:nowrap}',
    '.hpc-note{font-size:11px;color:#6b7390;margin:6px 2px 2px}',
    '@media (max-width:480px){.hpc{padding:12px 10px 8px}.hpc-row{padding:9px 8px 9px 32px;column-gap:4px}.hpc-dot{left:9px;width:14px;height:14px;margin-top:-7px}.hpc-head{padding:0 8px 6px 32px}.hpc-pack b,.hpc-price b{font-size:14px}.hpc-day{font-size:12px}}',
    '.product-info #productPrice .discount-percent{display:inline-block;margin-left:10px;padding:3px 10px;border-radius:99px;background:#dff5e6;color:#0f6b3a;font-size:13px;font-weight:700;vertical-align:middle}'
  ].join('\n');

  function money(paise) {
    return '\u20b9' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  function build(opts, variants) {
    var packs = [];
    variants.forEach(function (v) {
      var m = /(\d+)\s*capsules?/i.exec(String((v.options && v.options[0]) || v.title || ''));
      if (!m) return;
      var n = parseInt(m[1], 10), cmp = v.compare_at_price || 0;
      packs.push({
        v: v, name: (v.options && v.options[0]) || v.title, n: n,
        price: v.price, cmp: cmp > v.price ? cmp : 0,
        pct: cmp > v.price ? Math.round((cmp - v.price) / cmp * 100) : 0
      });
    });
    if (packs.length < 2) return null;
    packs.sort(function (a, b) { return a.n - b.n; });
    var best = null;
    packs.forEach(function (p) { if (p.pct > 0 && (!best || p.pct > best.pct)) best = p; });

    var wrap = document.createElement('div');
    wrap.className = 'hpc';
    var html = '<div class="hpc-title">Compare packs</div><div class="hpc-sub">Longer course, lower cost per day.</div>' +
      '<div class="hpc-grid hpc-head"><span>Pack</span><span>Price</span><span>You save</span><span>Per day</span></div>';
    packs.forEach(function (p) {
      html += '<button type="button" class="hpc-row" data-name="' + String(p.name).replace(/"/g, '&quot;') + '"' + (p.v.available ? '' : ' disabled') + '>' +
        '<span class="hpc-dot" aria-hidden="true"></span><span class="hpc-pack"><b>' + p.n + '-day</b><small>' + p.n + ' capsules</small>' + (best === p ? '<span class="hpc-best">Best value</span>' : '') + '</span>' +
        '<span class="hpc-price"><b>' + money(p.price) + '</b>' + (p.cmp ? '<s>' + money(p.cmp) + '</s>' : '') + '</span>' +
        '<span class="hpc-save">' + (p.pct ? '<span>Save ' + p.pct + '%</span>' : '<em>\u2014</em>') + '</span>' +
        '<span class="hpc-day">' + money(p.price / p.n) + '/day</span></button>';
    });
    wrap.innerHTML = html;

    function selectedName() {
      var el = opts.querySelector('.product-option__value.is-selected, .product-option__value[aria-pressed="true"]');
      return el ? el.getAttribute('data-option-value') : null;
    }
    function sync() {
      var sel = selectedName();
      wrap.querySelectorAll('.hpc-row').forEach(function (r) {
        var on = r.getAttribute('data-name') === sel;
        r.classList.toggle('is-selected', on);
        r.setAttribute('aria-pressed', String(on));
      });
    }
    wrap.addEventListener('click', function (e) {
      var row = e.target.closest('.hpc-row');
      if (!row || row.disabled) return;
      var name = row.getAttribute('data-name');
      var btns = opts.querySelectorAll('.product-option__value');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].getAttribute('data-option-value') === name) { btns[i].click(); break; }
      }
      setTimeout(sync, 0);
    });
    new MutationObserver(sync).observe(opts, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-pressed'] });
    sync();
    return wrap;
  }

  function init() {
    if (!document.getElementById('hpc-style')) {
      var st = document.createElement('style'); st.id = 'hpc-style'; st.textContent = CSS; document.head.appendChild(st);
    }
    document.querySelectorAll('.prod-hero-inner, #product .product-info').forEach(function (section) {
      var opts = section.querySelector('#productOptions');
      var json = section.querySelector('#ProductVariantsJSON');
      if (!opts || !json || opts.getAttribute('data-hpc')) return;
      var variants;
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      var table = build(opts, variants);
      if (!table) return;
      opts.setAttribute('data-hpc', '1');
      opts.insertAdjacentElement('afterend', table);
      opts.classList.add('hpc-opts-hidden'); // table is now the selector; buttons stay in the page (hidden) so cart/variant logic keeps working
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
